import * as Yup from 'yup';
import { Param } from '../../../../../../shared/types/param';

export const initialValues: Param = {
    name: '',
    active: true,
    code: '',
    class: '',
    extra: '',
};

export const validationSchema = (id: string) =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: id
            ? Yup.string().required('El descripción es obligatoria')
            : Yup.string().notRequired(),
    });
